import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { BookmarkPlus, X, Search, FileText } from 'lucide-react';

const SavedCareersSection = ({ savedCareers, onDeleteSavedCareer }) => {
  const navigate = useNavigate();

  if (savedCareers.length === 0) return null;

  return (
    <div className="mb-8 sm:mb-12">
      <div className="flex items-center justify-between mb-4 sm:mb-6">
        <h2 className="text-lg sm:text-2xl font-bold flex items-center">
          <BookmarkPlus className="w-5 h-5 sm:w-7 sm:h-7 mr-2 text-purple-600" />
          <span className="hidden sm:inline">Saved Careers & Job Titles</span>
          <span className="sm:hidden">Saved Careers</span>
        </h2>
        <span className="text-xs sm:text-sm text-gray-500">{savedCareers.length} saved</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
        {savedCareers.slice(0, 6).map((career) => (
          <div key={career.id} className="border border-purple-100 rounded-xl p-3 sm:p-4 bg-gradient-to-br from-purple-50 to-pink-50 hover:shadow-md transition-shadow">
            <div className="flex justify-between items-start mb-2">
              <h3 className="font-bold text-sm sm:text-base text-gray-900">{career.job_title}</h3>
              <button
                onClick={() => onDeleteSavedCareer(career.id)}
                className="text-gray-400 hover:text-red-600 transition-colors p-1 min-h-[44px] min-w-[44px] flex items-center justify-center"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
            {career.career_field && (
              <p className="text-xs text-gray-600 mb-2">{career.career_field}</p>
            )}
            {career.source_assessment && (
              <span className="text-xs bg-purple-100 text-purple-700 px-2 py-1 rounded">
                From {career.source_assessment.replace('-', ' ')}
              </span>
            )}
            <div className="mt-3 flex gap-2">
              <Button
                size="sm"
                variant="outline"
                onClick={() => navigate(`/jobs?query=${encodeURIComponent(career.job_title)}`)}
                className="flex-1 text-xs"
              >
                <Search className="w-3 h-3 mr-1" /> Search
              </Button>
              <Button
                size="sm"
                variant="outline"
                onClick={() => {
                  localStorage.setItem('targetJobTitle', career.job_title);
                  navigate('/resume/new');
                }}
                className="flex-1 text-xs"
              >
                <FileText className="w-3 h-3 mr-1" /> Resume
              </Button>
            </div>
          </div>
        ))}
      </div>
      {savedCareers.length > 6 && (
        <div className="mt-4 text-center">
          <span className="text-sm text-gray-600">Showing 6 of {savedCareers.length} saved careers</span>
        </div>
      )}
    </div>
  );
};

export default SavedCareersSection;
